import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { AuthContext, Loader, ViewContext } from "@/components/lib";
import Styles from "@/css/mainStyles";
import axios from "axios";

export default function DeactivateModal({ id, setOpen }) {
  const viewContext = useContext<any>(ViewContext);
  const context = useContext<any>(AuthContext);
  const { handleSubmit } = useForm();

  const [loading, setLoading] = useState(false);

  const deactivateAccountSubmit = async () => {
    const url = `/api/player/${id}`;

    try {
      setLoading(true);
      await axios({
        method: "patch",
        url,
        data: { disabled: true }
      });
      viewContext.notification.show("Account deactivated", "success");
      context.signout();
    } catch (error) {
      console.error(error);
      viewContext.notification.show(error.message, "error");
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(deactivateAccountSubmit)}>
      <h2 className="text-lg md:text-2xl font-bold mb-2">Deactivate Account</h2>
      <h3 className="text-sm md:text-2xl mb-4">
        Are you sure you want to deactivate your account?
      </h3>
      <p className="text-sm md:text-lg text-gray-600 mb-4">
        Deactivating your account will temporarily disable access and hide your
        profile and data from other users. You can reactivate it anytime by
        logging back in.
      </p>

      <div className="flex justify-between mt-4 gap-4">
        <button onClick={() => setOpen(false)} className={Styles.cancelButton}>
          Cancel
        </button>
        <button className={Styles.submitButton}>
          Confirm {loading && <Loader />}
        </button>
      </div>
    </form>
  );
}
